import { getLocalStorage as getStorage } from './storage';


export default function getUserRole() {
  return getStorage(['role']).role;
}
